import React from 'react';

const Atoz = () => {
    return (
        <div className='text-center mx-auto w-75 my-5'>
            <h1>Spices A to Z</h1>
            <p>From Adobo to Za'atar, the Spice House has every type of spice, herb, and <br />
                seasoning to create exquisite flavor in all your dishes.</p>
            <img className='img-fluid' src="https://cdn.shopify.com/s/files/1/0148/1945/9126/files/Spices_A-Z_Optimized_1296x.png?v=1573168212" alt="" />
        </div>
    );
};

export default Atoz;